import React from "react";
import { RotateCcw } from "lucide-react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };

function fmt(n, d = 2) {
  return Number(n).toLocaleString("fr-FR", { minimumFractionDigits: d, maximumFractionDigits: d });
}

export function BudgetHistory({ history, onUndo }) {
  if (!history || history.length === 0) return null;

  return (
    <div>
      <p className="text-xs uppercase tracking-widest text-[#8B5E34] mb-2" style={LORA}>
        Dernières dépenses
      </p>
      <div className="space-y-1.5">
        {history.slice(0, 5).map((entry) => (
          <div
            key={entry.id}
            className="flex items-center justify-between bg-white border border-[#DCD4C6] px-3 py-2.5"
            style={{ borderRadius: "2px" }}
            data-testid={`history-item-${entry.id}`}
          >
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-[#2B2623]" style={LORA}>
                -{fmt(entry.amountEur)} €
                {entry.originalCurrency !== "EUR" && (
                  <span className="text-xs text-[#9A8F86] font-normal ml-1.5">
                    (conv. {fmt(entry.originalAmount, entry.originalAmount < 100 ? 2 : 0)} {entry.originalCurrency})
                  </span>
                )}
              </p>
              <p className="text-xs text-[#9A8F86] truncate mt-0.5" style={LORA}>
                {entry.label}
              </p>
            </div>
            <button
              onClick={() => onUndo(entry.id)}
              className="flex items-center gap-1 ml-3 text-xs text-[#C17F59] hover:text-[#A86A46] transition-colors flex-shrink-0"
              style={LORA}
              data-testid={`btn-undo-${entry.id}`}
            >
              <RotateCcw size={11} strokeWidth={1.5} /> Annuler
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
